import { render } from "./BaseButton.vue?vue&type=template&id=0147d3d1"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=0147d3d1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__